import type { ModifiableElementType } from "schemas/generated/fileModifiers";

import React from "react";

import {
  Link,
  LucideImagePlay,
  ShoppingBag,
  Sparkles,
  SquareDashed,
  Type,
  Zap,
} from "lucide-react";
import { exhaustiveSwitch } from "replo-utils/lib/misc";

function getElementDisplay(elementType: ModifiableElementType) {
  return exhaustiveSwitch({ type: elementType })({
    text: () => ({ Icon: Type, label: "Text" }),
    container: () => ({ Icon: SquareDashed, label: "Container" }),
    image: () => ({ Icon: LucideImagePlay, label: "Media" }),
    video: () => ({ Icon: LucideImagePlay, label: "Media" }),
    "product-section": () => ({ Icon: ShoppingBag, label: "Buy Box" }),
    button: () => ({ Icon: Zap, label: "Button" }),
    icon: () => ({ Icon: Sparkles, label: "Icon" }),
    unknown: () => ({ Icon: SquareDashed, label: "Unknown" }),
    link: () => ({ Icon: Link, label: "Link" }),
  });
}

export const SelectedElementToken: React.FC<{
  data: { elementType: ModifiableElementType; stableElementId: string };
}> = ({ data }) => {
  const { Icon, label } = getElementDisplay(data.elementType);

  return (
    <span className="inline-flex items-center align-middle max-w-full p-1 border-[0.5px] border-border bg-sheet rounded-md">
      <Icon className="w-4 h-4 text-muted-foreground mr-1 shrink-0" />
      <span className="font-medium text-default truncate">{label}</span>
    </span>
  );
};
